import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const KEY = "cp_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (product) => {
    setItems((prev) => {
      if (prev.find((p) => p.product_id === product.id)) {
        toast.info("Cet eBook est déjà dans votre panier.");
        return prev;
      }
      toast.success(`${product.title} ajouté au panier`);
      return [...prev, {
        product_id: product.id, slug: product.slug, title: product.title,
        price: product.price, cover_url: product.cover_url, is_pack: product.is_pack,
      }];
    });
  };

  const removeItem = (product_id) => setItems((prev) => prev.filter((p) => p.product_id !== product_id));
  const clear = () => setItems([]);
  const has = (product_id) => items.some((p) => p.product_id === product_id);
  const subtotal = items.reduce((s, i) => s + i.price, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clear, has, subtotal, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
